// Core
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';

import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';


// Styles
import './styles.scss';
import Button from 'components/commonComponents/Button';
import { fetchData } from 'utils/fetch';
import { restAPIs } from 'utils/restAPIs';
import Article from 'components/commonComponents/Article';
import Skelton from 'components/commonComponents/Skelton';
import { useNavigate } from 'react-router-dom';

const ArticlesByLocationModal = (props) => {
  const { onClose, open, location, tripId } = props;
  const [articles, setArticles] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleClose = (event, reason) => {
    if (reason === "backdropClick") {
      console.log(reason);
    } else {
      onClose();
    }
  };

  const handleOnClickArticle = (id) => {
    navigate('/article/' + tripId + '/' + id);
    onClose();
  }

  const fetchArticles = async () => {
    setIsLoading(true)
    const res = await fetchData(restAPIs.articlesByLocationName(tripId, location.locationName));
    setIsLoading(false)
    if (res?.statusCode === 200) {
      setArticles(res.articles);
    }
  };


  useEffect(() => {
    fetchArticles();
  }, [location]);


  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        className='__common_model_class'
        maxWidth={'sm'}
        fullWidth={true}
        disableEscapeKeyDown
      >
        <DialogTitle id="alert-dialog-title">
          {t('articles')}
        </DialogTitle>
        <DialogContent>

          <div className='__article-list'>
            {isLoading ?
              [...Array(2)].map((item, idx) => {
                return (
                  <Skelton key={idx} />
                )
              })
              :
              articles && articles?.map((item, idx) => {
                return (
                  <div style={{ position: 'relative' }}>
                    <Article
                      key={idx}
                      title={item.articleName}
                      para={item.displayDate}
                      image={item.coverImage}
                      handleOnClick={() => handleOnClickArticle(item.articleId)}
                    />
                  </div>
                )
              })
            }
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>

        </DialogContent>
        <DialogActions>
          <div className='d-flex align-items-center' style={{ margin: '15px' }}>
            <Button
              handleOnClick={handleClose}
              label={t('cancel')}
            />
          </div>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ArticlesByLocationModal;

ArticlesByLocationModal.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool,
  location: PropTypes.any,
  tripId: PropTypes.any,
};
